import { render, staticRenderFns } from "./pagination.component.vue?vue&type=template&id=5fa1f4a9&scoped=true&"
import script from "./pagination.component.vue?vue&type=script&lang=ts&"
export * from "./pagination.component.vue?vue&type=script&lang=ts&"
import style0 from "./pagination.component.vue?vue&type=style&index=0&id=5fa1f4a9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa1f4a9",
  null
  
)

export default component.exports